/**
 * 1stdibs
 * User: James
 * Date: 11/19/13
 */

'use strict';

var root = typeof window === 'undefined' ? global : window;
var checkVals = { checkedVal: 'Y', unCheckedVal: 'N' };
var _ = require('underscore');
var Backbone;
var $;

// do not load twice
if (root._dibsBackbone) {
	module.exports = root._dibsBackbone;
} else {
	Backbone = require('backbone-base-and-form-view');
	var bbAss = require('./backboneAssociations');
	bbAss(Backbone);
	
	$ = require('dibs-jquery-shim');

	Backbone.$ = $;
	Backbone.FormView.prototype.className = 'form-horizontal form-horizontal-default';
	Backbone.fields.FieldView.prototype.classDefaults = 'form-group form-field';
	Backbone.fields.FieldView.prototype.template = _.template(
	    '<% if (obj.label) { %><label class="control-label" ' +
	        '<% if (obj.inputId) { %> for="<%= obj.inputId %>" <% } %> >' +
	        '<%= obj.label %></label><% } %>' +
	        '<div class="controls-wrapper">' +
	        '   <div class="controls" data-input=""></div>' +
	        '<div class="controls">' +
	        '<div class="text-error" data-error=""></div>' +
	        '<% if (obj.help) { %><span class="help-block"><%= obj.help %></span><% } %>' +
	        '</div>'
	);

	_.extend(Backbone.fields.CheckListView.prototype, checkVals);
	_.extend(Backbone.fields.CheckBoxView.prototype, checkVals);

	module.exports = root._dibsBackbone = Backbone;
}



//////////////////
// WEBPACK FOOTER
// ./~/dibs-backbone/dibsBackbone.js
// module id = 2702
// module chunks = 64